<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre4" id="untitled-1"></div>
<div class="calibre1">
<div class="calibre1">
<p class="normal"><span class="no-style-override5"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="normal"><span class="no-style-override10">He stands on the edge of a foul dark pond as the cold winds of hell howl around him. In his cruel hands, he holds a collection of shiny pebbles that represent every child he took, subjected to unspeakable horrors and pain, and then remorselessly killed in the most terrifying manner imaginable. With each murder, the monster, this bogeyman, this nightmare, tosses a pebble into the bottomless waters causing ripples of misery and devastation to spread outward, engulfing his victims, their families, friends, police officers, communities, and even, as these sorts of beyond- the-pale atrocities becomes public knowledge, the national consciousness. They erode how secure we feel in our homes, how safe our children are playing in the yard, whether evil is winning the battle...</span></p>
<p class="calibre3" id="calibre_pb_14"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Opening.vue?bacc939c